import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import allPlusSrc from './images/all-plus.avif';

const allPlusBenefits = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: '...and AllTrails Plus benefits!' }),
  subheadline: intl.formatMessage({
    defaultMessage: 'Unlimited map downloads, real-time trail conditions, wrong-turn alerts, 3D trail previews and more!'
  }),
  thumbnailImage: allPlusSrc.src
});

export default allPlusBenefits;
